// import React, { useState, useEffect } from 'react';
// import { Container, Card, Button, Modal, Row, Col, Spinner } from 'react-bootstrap';
// import {
//   FaFileContract, FaEye, FaSearch, FaTimes, FaRedo,
//   FaClock, FaPaperPlane, FaCheckCircle, FaTimesCircle,
//   FaExternalLinkAlt, FaUser, FaCalendarAlt, FaFileSignature
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// import { PageHeader } from '../../components/shared/PageHeader';
// import { SearchFilterBar } from '../../components/shared/SearchFilterBar';
// import { DataTable } from '../../components/shared/DataTable';

// const COLUMNS = ['Cliente', 'Plano / Pedido', 'Criado em', 'Envio', 'Assinatura', 'Status', 'Ações'];

// // ─────────────────────────────────────────
// // UTILS
// // ─────────────────────────────────────────
// const formatBr = (v) => {
//   if (!v) return '-';
//   const d = new Date(v);
//   if (isNaN(d)) return '-';
//   return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
// };

// const normalizeStatus = (status) => {
//   const upper = String(status || '').trim().toUpperCase();

//   if (upper === 'DRAFT') return 'pendente';
//   if (upper === 'SENT') return 'aguardando_assinatura';
//   if (upper === 'SIGNED') return 'assinado';
//   if (['CANCELED', 'CANCELLED', 'DISPENSED'].includes(upper)) return 'dispensado';

//   const lower = String(status || '').toLowerCase();
//   if (['pendente', 'aguardando_assinatura', 'assinado', 'dispensado'].includes(lower)) return lower;

//   return 'pendente';
// };

// const STATUS_MAP = {
//   pendente:              { icon: FaClock,       text: 'Pendente',           color: '#6c757d', textColor: '#fff' },
//   aguardando_assinatura: { icon: FaPaperPlane,  text: 'Aguard. Assinatura', color: '#ffc107', textColor: '#000' },
//   assinado:              { icon: FaCheckCircle, text: 'Assinado',           color: '#198754', textColor: '#fff' },
//   dispensado:            { icon: FaTimesCircle, text: 'Dispensado',         color: '#0dcaf0', textColor: '#000' },
// };

// const StatusBadge = ({ status }) => {
//   const cfg = STATUS_MAP[status] || STATUS_MAP.pendente;
//   const Icon = cfg.icon;

//   return (
//     <span
//       className="d-inline-flex align-items-center gap-1 fw-semibold rounded-pill"
//       style={{
//         backgroundColor: cfg.color,
//         color: cfg.textColor,
//         fontSize: '0.72rem',
//         padding: '0.3rem 0.65rem',
//         lineHeight: 1,
//       }}
//     >
//       <Icon size={10} />
//       {cfg.text}
//     </span>
//   );
// };

// // ─────────────────────────────────────────
// // EXTRAI CONTRATOS A PARTIR DOS PEDIDOS
// // ─────────────────────────────────────────
// const extractContractsFromOrders = (orders) => {
//   const contratos = [];

//   orders.forEach((order) => {
//     (order.contracts || []).forEach((contract) => {
//       contratos.push({
//         id: contract.id,
//         orderId: order.id,
//         status: normalizeStatus(contract.status),
//         link: contract.link || null,
//         autentiqueId: contract.autentiqueId || null,
//         createdAt: contract.createdAt || order.createdAt || null,
//         sentAt: contract.sentAt || null,
//         signedAt: contract.signedAt || null,

//         clienteNome: order.customer?.name || 'Cliente Desconhecido',
//         clienteEmail: order.customer?.email || '',
//         clienteDoc: order.customer?.cnpj || order.customer?.document || '',

//         planoNome: order.mediaPlan?.name || 'Plano Desconhecido',
//         startDate: order.startDate ? order.startDate.split('T')[0] : '',
//         endDate: order.endDate ? order.endDate.split('T')[0] : '',
//       });
//     });
//   });

//   // mais recentes primeiro
//   return contratos.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
// };

// // ─────────────────────────────────────────
// // PÁGINA PRINCIPAL
// // ─────────────────────────────────────────
// export default function Contratos() {
//   const [contratos, setContratos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('');

//   const [showModal, setShowModal] = useState(false);
//   const [current, setCurrent] = useState(null);

//   const fetchContratos = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get('/orders');
//       setContratos(extractContractsFromOrders(res.data));
//     } catch {
//       toast.error('Erro ao carregar contratos.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchContratos();
//   }, []);

//   const filtered = contratos.filter((c) => {
//     const term = searchTerm.toLowerCase();
//     const matchSearch =
//       !term ||
//       c.clienteNome?.toLowerCase().includes(term) ||
//       c.planoNome?.toLowerCase().includes(term) ||
//       c.clienteEmail?.toLowerCase().includes(term) ||
//       String(c.orderId).includes(term);

//     const matchStatus = !statusFilter || c.status === statusFilter;

//     return matchSearch && matchStatus;
//   });

//   const handleView = (contrato) => {
//     setCurrent(contrato);
//     setShowModal(true);
//   };

//   return (
//     <Container fluid className="p-4">
//       <PageHeader title="Contratos" />

//       {/* ── Filtros ── */}
//       <Card className="mb-4 shadow-sm border-0">
//         <Card.Body>
//           <Row className="g-3 align-items-end">
//             <Col md={6}>
//               <SearchFilterBar
//                 searchTerm={searchTerm}
//                 onSearchChange={setSearchTerm}
//                 searchPlaceholder="Buscar por cliente, plano, pedido..."
//               />
//             </Col>

//             <Col md={4}>
//               <label className="small text-muted mb-1 d-block">Status do Contrato</label>
//               <select
//                 className="form-select form-select-sm"
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//               >
//                 <option value="">Todos</option>
//                 <option value="pendente">Pendente</option>
//                 <option value="aguardando_assinatura">Aguardando Assinatura</option>
//                 <option value="assinado">Assinado</option>
//                 <option value="dispensado">Dispensado</option>
//               </select>
//             </Col>

//             <Col md={2} className="d-flex gap-2">
//               <Button
//                 variant="outline-secondary"
//                 size="sm"
//                 className="w-100"
//                 onClick={() => { setSearchTerm(''); setStatusFilter(''); }}
//               >
//                 <FaTimes className="me-1" />
//                 Limpar
//               </Button>

//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={fetchContratos}
//                 title="Atualizar"
//               >
//                 <FaRedo />
//               </Button>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* ── Tabela ── */}
//       <DataTable
//         columns={COLUMNS}
//         loading={loading}
//         emptyMessage="Nenhum contrato encontrado."
//       >
//         {filtered.length > 0 && filtered.map((c) => (
//           <tr key={c.id}>
//             <td>
//               <div className="d-flex align-items-center gap-2">
//                 <FaFileContract className="text-primary flex-shrink-0" />
//                 <div>
//                   <strong>{c.clienteNome}</strong>
//                   {c.clienteEmail && (
//                     <>
//                       <br />
//                       <small className="text-muted">{c.clienteEmail}</small>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </td>

//             <td>
//               <span className="d-block">{c.planoNome}</span>
//               <small className="text-muted">Pedido #{c.orderId}</small>
//             </td>

//             <td>{formatBr(c.createdAt)}</td>
//             <td>{formatBr(c.sentAt)}</td>
//             <td>{formatBr(c.signedAt)}</td>

//             <td><StatusBadge status={c.status} /></td>

//             <td>
//               <div className="d-flex gap-1">
//                 <Button
//                   variant="outline-primary"
//                   size="sm"
//                   title="Ver detalhes"
//                   onClick={() => handleView(c)}
//                 >
//                   <FaEye />
//                 </Button>

//                 {c.link && (
//                   <Button
//                     variant="outline-success"
//                     size="sm"
//                     title="Abrir contrato/assinatura"
//                     onClick={() => window.open(c.link, '_blank')}
//                   >
//                     <FaExternalLinkAlt />
//                   </Button>
//                 )}
//               </div>
//             </td>
//           </tr>
//         ))}
//       </DataTable>

//       {/* ── Modal Detalhes ── */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="d-flex align-items-center gap-2">
//             <FaFileContract className="text-primary" />
//             Detalhes do Contrato
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {current && (
//             <>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <StatusBadge status={current.status} />
//                 <small className="text-muted">Pedido #{current.orderId}</small>
//               </div>

//               <Row className="g-3">
//                 <Col md={6}>
//                   <small className="text-muted d-block"><FaUser className="me-1" /> Cliente</small>
//                   <strong>{current.clienteNome}</strong>
//                   {current.clienteDoc && <div><small>{current.clienteDoc}</small></div>}
//                   {current.clienteEmail && <div><small className="text-muted">{current.clienteEmail}</small></div>}
//                 </Col>

//                 <Col md={6}>
//                   <small className="text-muted d-block"><FaFileSignature className="me-1" /> Plano</small>
//                   <strong>{current.planoNome}</strong>
//                 </Col>

//                 <Col md={6}>
//                   <small className="text-muted d-block"><FaCalendarAlt className="me-1" /> Período</small>
//                   <strong>{formatBr(current.startDate)} → {formatBr(current.endDate)}</strong>
//                 </Col>

//                 <Col md={6}>
//                   <small className="text-muted d-block">Datas do Contrato</small>
//                   <div><small><strong>Criado:</strong> {formatBr(current.createdAt)}</small></div>
//                   <div><small><strong>Enviado:</strong> {formatBr(current.sentAt)}</small></div>
//                   <div><small><strong>Assinado:</strong> {formatBr(current.signedAt)}</small></div>
//                 </Col>

//                 {current.autentiqueId && (
//                   <Col md={12}>
//                     <small className="text-muted d-block">ID Autentique</small>
//                     <code>{current.autentiqueId}</code>
//                   </Col>
//                 )}
//               </Row>
//             </>
//           )}
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             <FaTimes className="me-1" /> Fechar
//           </Button>

//           {current?.link && (
//             <Button variant="success" onClick={() => window.open(current.link, '_blank')}>
//               <FaExternalLinkAlt className="me-1" /> Abrir Contrato
//             </Button>
//           )}
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Modal, Row, Col, Spinner } from 'react-bootstrap';
import {
  FaFileContract, FaEye, FaSearch, FaTimes, FaRedo,
  FaClock, FaPaperPlane, FaCheckCircle, FaTimesCircle,
  FaExternalLinkAlt, FaUser, FaCalendarAlt, FaFileSignature,
  FaFilePdf
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';

import { PageHeader } from '../../components/shared/PageHeader';
import { SearchFilterBar } from '../../components/shared/SearchFilterBar';
import { DataTable } from '../../components/shared/DataTable';

const COLUMNS = ['Cliente', 'Plano / Pedido', 'Criado em', 'Envio', 'Assinatura', 'Status', 'Ações'];

// ─────────────────────────────────────────
// UTILS
// ─────────────────────────────────────────
const formatBr = (v) => {
  if (!v) return '-';
  const d = new Date(v);
  if (isNaN(d)) return '-';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// 🔑 Data + hora (útil para envio/assinatura)
const formatBrDateTime = (v) => {
  if (!v) return '-';
  const d = new Date(v);
  if (isNaN(d)) return '-';
  const data = d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const hora = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${data} às ${hora}`;
};

const normalizeStatus = (status) => {
  const upper = String(status || '').trim().toUpperCase();

  if (upper === 'DRAFT') return 'pendente';
  if (upper === 'SENT') return 'aguardando_assinatura';
  if (upper === 'SIGNED') return 'assinado';
  if (['CANCELED', 'CANCELLED', 'REJECTED', 'DISPENSED'].includes(upper)) return 'dispensado';

  const lower = String(status || '').toLowerCase();
  if (['pendente', 'aguardando_assinatura', 'assinado', 'dispensado'].includes(lower)) return lower;

  return 'pendente';
};

const STATUS_MAP = {
  pendente:              { icon: FaClock,       text: 'Pendente',           color: '#6c757d', textColor: '#fff' },
  aguardando_assinatura: { icon: FaPaperPlane,  text: 'Aguard. Assinatura', color: '#ffc107', textColor: '#000' },
  assinado:              { icon: FaCheckCircle, text: 'Assinado',           color: '#198754', textColor: '#fff' },
  dispensado:            { icon: FaTimesCircle, text: 'Dispensado',         color: '#0dcaf0', textColor: '#000' },
};

const StatusBadge = ({ status }) => {
  const cfg = STATUS_MAP[status] || STATUS_MAP.pendente;
  const Icon = cfg.icon;

  return (
    <span
      className="d-inline-flex align-items-center gap-1 fw-semibold rounded-pill"
      style={{
        backgroundColor: cfg.color,
        color: cfg.textColor,
        fontSize: '0.72rem',
        padding: '0.3rem 0.65rem',
        lineHeight: 1,
      }}
    >
      <Icon size={10} />
      {cfg.text}
    </span>
  );
};

// ─────────────────────────────────────────
// EXTRAI CONTRATOS A PARTIR DOS PEDIDOS
// (campos alinhados ao schema Prisma)
// ─────────────────────────────────────────
const extractContractsFromOrders = (orders) => {
  const contratos = [];

  orders.forEach((order) => {
    (order.contracts || []).forEach((contract) => {
      contratos.push({
        id: contract.id,
        orderId: order.id,
        status: normalizeStatus(contract.status),

        // 🔑 nomes corretos do schema
        signatureLink: contract.signatureLink || null,
        signedDocumentUrl: contract.signedDocumentUrl || null,
        autentiqueDocId: contract.autentiqueDocId || null,

        createdAt: contract.createdAt || order.createdAt || null,
        sentAt: contract.sentAt || null,
        signedAt: contract.signedAt || null,

        clienteNome: order.customer?.name || 'Cliente Desconhecido',
        clienteEmail: order.customer?.email || '',
        clienteDoc: order.customer?.cnpj || order.customer?.document || '',

        planoNome: order.mediaPlan?.name || 'Plano Desconhecido',
        startDate: order.startDate ? order.startDate.split('T')[0] : '',
        endDate: order.endDate ? order.endDate.split('T')[0] : '',
      });
    });
  });

  // mais recentes primeiro
  return contratos.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
};

// ─────────────────────────────────────────
// PÁGINA PRINCIPAL
// ─────────────────────────────────────────
export default function Contratos() {
  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(null);
  const [downloadingPdf, setDownloadingPdf] = useState(false); // 🔑 PDF assinado

  const fetchContratos = async () => {
    try {
      setLoading(true);
      const res = await api.get('/orders');
      setContratos(extractContractsFromOrders(res.data));
    } catch {
      toast.error('Erro ao carregar contratos.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContratos();
  }, []);

  const filtered = contratos.filter((c) => {
    const term = searchTerm.toLowerCase();
    const matchSearch =
      !term ||
      c.clienteNome?.toLowerCase().includes(term) ||
      c.planoNome?.toLowerCase().includes(term) ||
      c.clienteEmail?.toLowerCase().includes(term) ||
      String(c.orderId).includes(term);

    const matchStatus = !statusFilter || c.status === statusFilter;

    return matchSearch && matchStatus;
  });

  const handleView = (contrato) => {
    setCurrent(contrato);
    setShowModal(true);
  };

  // 🔑 Download do PDF assinado: URL direta OU proxy do backend
  const handleDownloadSignedPdf = async (contrato) => {
    if (!contrato) return;

    // 1) URL pública direta → abre direto
    if (contrato.signedDocumentUrl) {
      window.open(contrato.signedDocumentUrl, '_blank');
      return;
    }

    // 2) Senão, usa o proxy do backend (com token)
    if (!contrato.id) {
      toast.warning('Contrato não disponível para download.');
      return;
    }

    setDownloadingPdf(true);
    try {
      const response = await api.get(
        `/contracts/${contrato.id}/signed-pdf`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);

      toast.success('PDF assinado aberto!');
    } catch (err) {
      let msg = 'Erro ao baixar PDF assinado.';
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          msg = JSON.parse(text).error || msg;
        } catch {
          // ignora
        }
      } else {
        msg = err.response?.data?.error || msg;
      }
      toast.error(msg);
    } finally {
      setDownloadingPdf(false);
    }
  };

  return (
    <Container fluid className="p-4">
      <PageHeader title="Contratos" />

      {/* ── Filtros ── */}
      <Card className="mb-4 shadow-sm border-0">
        <Card.Body>
          <Row className="g-3 align-items-end">
            <Col md={6}>
              <SearchFilterBar
                searchTerm={searchTerm}
                onSearchChange={setSearchTerm}
                searchPlaceholder="Buscar por cliente, plano, pedido..."
              />
            </Col>

            <Col md={4}>
              <label className="small text-muted mb-1 d-block">Status do Contrato</label>
              <select
                className="form-select form-select-sm"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="pendente">Pendente</option>
                <option value="aguardando_assinatura">Aguardando Assinatura</option>
                <option value="assinado">Assinado</option>
                <option value="dispensado">Dispensado</option>
              </select>
            </Col>

            <Col md={2} className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                size="sm"
                className="w-100"
                onClick={() => { setSearchTerm(''); setStatusFilter(''); }}
              >
                <FaTimes className="me-1" />
                Limpar
              </Button>

              <Button
                variant="outline-primary"
                size="sm"
                onClick={fetchContratos}
                title="Atualizar"
              >
                <FaRedo />
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ── Tabela ── */}
      <DataTable
        columns={COLUMNS}
        loading={loading}
        emptyMessage="Nenhum contrato encontrado."
      >
        {filtered.length > 0 && filtered.map((c) => (
          <tr key={c.id}>
            <td>
              <div className="d-flex align-items-center gap-2">
                <FaFileContract className="text-primary flex-shrink-0" />
                <div>
                  <strong>{c.clienteNome}</strong>
                  {c.clienteEmail && (
                    <>
                      <br />
                      <small className="text-muted">{c.clienteEmail}</small>
                    </>
                  )}
                </div>
              </div>
            </td>

            <td>
              <span className="d-block">{c.planoNome}</span>
              <small className="text-muted">Pedido #{c.orderId}</small>
            </td>

            <td>{formatBr(c.createdAt)}</td>
            <td>{formatBr(c.sentAt)}</td>
            <td>{formatBr(c.signedAt)}</td>

            <td><StatusBadge status={c.status} /></td>

            <td>
              <div className="d-flex gap-1">
                <Button
                  variant="outline-primary"
                  size="sm"
                  title="Ver detalhes"
                  onClick={() => handleView(c)}
                >
                  <FaEye />
                </Button>

                {/* Link de assinatura (enquanto NÃO assinado) */}
                {c.signatureLink && c.status !== 'assinado' && (
                  <Button
                    variant="outline-warning"
                    size="sm"
                    title="Abrir link de assinatura"
                    onClick={() => window.open(c.signatureLink, '_blank')}
                  >
                    <FaExternalLinkAlt />
                  </Button>
                )}

                {/* PDF assinado (quando assinado) */}
                {c.status === 'assinado' && (c.signedDocumentUrl || c.id) && (
                  <Button
                    variant="outline-success"
                    size="sm"
                    title="Baixar PDF assinado"
                    disabled={downloadingPdf}
                    onClick={() => handleDownloadSignedPdf(c)}
                  >
                    {downloadingPdf
                      ? <Spinner animation="border" size="sm" />
                      : <FaFilePdf />
                    }
                  </Button>
                )}
              </div>
            </td>
          </tr>
        ))}
      </DataTable>

      {/* ── Modal Detalhes ── */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            <FaFileContract className="text-primary" />
            Detalhes do Contrato
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {current && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <StatusBadge status={current.status} />
                <small className="text-muted">Pedido #{current.orderId}</small>
              </div>

              <Row className="g-3">
                <Col md={6}>
                  <small className="text-muted d-block"><FaUser className="me-1" /> Cliente</small>
                  <strong>{current.clienteNome}</strong>
                  {current.clienteDoc && <div><small>{current.clienteDoc}</small></div>}
                  {current.clienteEmail && <div><small className="text-muted">{current.clienteEmail}</small></div>}
                </Col>

                <Col md={6}>
                  <small className="text-muted d-block"><FaFileSignature className="me-1" /> Plano</small>
                  <strong>{current.planoNome}</strong>
                </Col>

                <Col md={6}>
                  <small className="text-muted d-block"><FaCalendarAlt className="me-1" /> Período</small>
                  <strong>{formatBr(current.startDate)} → {formatBr(current.endDate)}</strong>
                </Col>

                <Col md={6}>
                  <small className="text-muted d-block">Datas do Contrato</small>
                  <div><small><strong>Criado:</strong> {formatBr(current.createdAt)}</small></div>
                  <div><small><strong>Enviado:</strong> {formatBrDateTime(current.sentAt)}</small></div>
                  <div><small><strong>Assinado:</strong> {formatBrDateTime(current.signedAt)}</small></div>
                </Col>

                {current.autentiqueDocId && (
                  <Col md={12}>
                    <small className="text-muted d-block">ID Autentique</small>
                    <code>{current.autentiqueDocId}</code>
                  </Col>
                )}
              </Row>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            <FaTimes className="me-1" /> Fechar
          </Button>

          {/* Link de assinatura no rodapé (enquanto NÃO assinado) */}
          {current?.signatureLink && current?.status !== 'assinado' && (
            <Button variant="warning" onClick={() => window.open(current.signatureLink, '_blank')}>
              <FaExternalLinkAlt className="me-1" /> Abrir Assinatura
            </Button>
          )}

          {/* PDF assinado no rodapé (quando assinado) */}
          {current?.status === 'assinado' && (current?.signedDocumentUrl || current?.id) && (
            <Button
              variant="success"
              disabled={downloadingPdf}
              onClick={() => handleDownloadSignedPdf(current)}
            >
              {downloadingPdf ? (
                <>
                  <Spinner animation="border" size="sm" className="me-1" />
                  Baixando...
                </>
              ) : (
                <>
                  <FaFilePdf className="me-1" /> Baixar PDF Assinado
                </>
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
